import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { CloseIcon } from "../atoms/icons/CloseIcon";
import { FileUploadFilterForm } from "./form/FileUploadFilterForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onReset: () => void;
  onFilter: (payload: {
    fileName?: string;
    userId?: string;
    menuId?: number;
    templateId?: number;
    fromDate?: string;
    toDate?: string;
    status?: number;
  }) => void;
  onMethods?: (methods: UseFormReturn<FieldValues, unknown, FieldValues>) => void;
};

export const Filter: React.FC<Props> = ({
  isOpen,
  onClose,
  onReset,
  onFilter,
  onMethods,
}) => {
  return (
    <StyledFilterContainer $isOpen={isOpen}>
      <StyledCloseButton onClick={onClose}>
        <CloseIcon />
      </StyledCloseButton>

      <FileUploadFilterForm
        onReset={onReset}
        handleSubmit={onFilter}
        onMethods={onMethods}
      />
    </StyledFilterContainer>
  );
};

const StyledFilterContainer = styled.div<{ $isOpen: boolean }>`
  position: relative;
  border-radius: 8px;
  background-color: #f2f2f2;
  overflow: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  max-height: ${({ $isOpen }) => ($isOpen ? "100vh" : "0px")};
  transition: max-height 0.2s ease;
`;

const StyledCloseButton = styled.div`
  position: absolute;
  top: 9px;
  right: 12px;
  cursor: pointer;
`;
